exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#edit-member input.search-box[data-v-68d5c050]{height:25px;font-size:14px;padding:0\n}\n#edit-member input.search-box[data-v-68d5c050]::placeholder{color:#bdbdbd;font-size:14px;text-align:center\n}", ""]);

// exports
